/**
 * Loftsails Product Gallery
 * Opens the PhotoSwipe lightbox when clicking product images (desktop + mobile).
 */
(function () {
  'use strict';

  var initialized = new WeakSet();
  var patchedOpenLightBox = false;

  function isInteractiveTarget(target) {
    return Boolean(target.closest('button, a[href], open-lightbox-button'));
  }

  function parseDimension(value, fallback) {
    var parsed = parseInt(value, 10);
    return parsed > 0 ? parsed : fallback;
  }

  function buildLightboxDataSource(gallery) {
    return gallery.carousel.cells
      .filter(function (cell) {
        return cell.getAttribute('data-media-type') === 'image';
      })
      .map(function (cell) {
        var img = cell.querySelector('img');
        if (!img) {
          return null;
        }

        return {
          thumbnailElement: img,
          src: img.currentSrc || img.src,
          srcset: img.srcset || '',
          msrc: img.currentSrc || img.src,
          width: parseDimension(img.getAttribute('width'), img.naturalWidth || 1200),
          height: parseDimension(img.getAttribute('height'), img.naturalHeight || 1200),
          alt: img.alt,
          thumbCropped: true
        };
      })
      .filter(Boolean);
  }

  function resolveLightboxIndex(gallery, index) {
    var imageCells = gallery.carousel.cells.filter(function (cell) {
      return cell.getAttribute('data-media-type') === 'image';
    });

    if (typeof index === 'number' && index >= 0 && index < imageCells.length) {
      return index;
    }

    var selectedIndex = imageCells.indexOf(gallery.carousel.selectedCell);
    return selectedIndex >= 0 ? selectedIndex : 0;
  }

  function patchOpenLightBox() {
    if (patchedOpenLightBox) {
      return;
    }

    customElements.whenDefined('product-gallery').then(function () {
      if (patchedOpenLightBox) {
        return;
      }

      var proto = customElements.get('product-gallery').prototype;
      proto.openLightBox = function (index) {
        var dataSource = buildLightboxDataSource(this);
        if (dataSource.length === 0) {
          return;
        }

        this.lightBox.loadAndOpen(resolveLightboxIndex(this, index), dataSource);
      };

      patchedOpenLightBox = true;
      initLoftsailsProductGalleries();
    });
  }

  function bindGallery(gallery) {
    if (initialized.has(gallery)) {
      return;
    }

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel || typeof gallery.openLightBox !== 'function') {
      return;
    }

    carousel.addEventListener('click', function (event) {
      if (isInteractiveTarget(event.target)) {
        return;
      }

      var mediaCell = event.target.closest('.product-gallery__media');
      if (!mediaCell || mediaCell.getAttribute('data-media-type') !== 'image') {
        return;
      }

      var imageCells = gallery.carousel.cells.filter(function (cell) {
        return cell.getAttribute('data-media-type') === 'image';
      });

      var index = imageCells.indexOf(mediaCell);
      if (index < 0) {
        index = imageCells.indexOf(gallery.carousel.selectedCell);
      }

      if (index >= 0) {
        event.preventDefault();
        gallery.openLightBox(index);
      }
    });

    initialized.add(gallery);
  }

  function initLoftsailsProductGalleries() {
    document.querySelectorAll('product-gallery[allow-zoom]').forEach(bindGallery);
  }

  patchOpenLightBox();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoftsailsProductGalleries);
  } else {
    initLoftsailsProductGalleries();
  }

  document.addEventListener('shopify:section:load', initLoftsailsProductGalleries);
  document.addEventListener('loftsails:product:updated', initLoftsailsProductGalleries);
})();
